// extracted by mini-css-extract-plugin
module.exports = {"content":"SideWidget_content"};